import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './committedOrders.consts';
import { UpdateParams, OrderParams } from 'store/orders';
import { normalizeDateFromApi } from 'helpers/datetimeHelpers';

function normalizeApiReponse(data: OrderParams) {
  const parseTimestamp = (timestamp: any) => {
    if (typeof timestamp === 'number' && timestamp.toString().includes('.')) {
      // Rozdzielenie sekund i ułamków sekund
      const seconds = Math.floor(timestamp); // Część całkowita (sekundy)
      const milliseconds = Math.round((timestamp - seconds) * 1000); // Ułamki sekund na milisekundy
      return new Date(seconds * 1000 + milliseconds); // Tworzenie daty
    }
    return timestamp; // Jeśli nie jest w formacie z ułamkami, zwróć oryginalną wartość
  };

  const currentUpdate = {
    ...data.currentUpdate,
    uploadDate: normalizeDateFromApi(
      parseTimestamp(data.currentUpdate.uploadDate),
    ),
  };
  const updates = data.updates.map((update: UpdateParams) => ({
    ...update,
    uploadDate: normalizeDateFromApi(parseTimestamp(update.uploadDate)),
  }));
  return {
    ...data,
    currentUpdate,
    updates,
  };
}

export const fetchAllCommittedOrdersOfCommittedBasket = createAsyncThunk(
  REDUCER_KEY + '/fetchAll',
  withErrorHandling(async ({ basketId }: { basketId: number }) => {
    const response = await adserver({
      url: `/basket/${basketId}/committed/orders`,
      headers: {},
    });
    return response.data.map((order: OrderParams) => ({
      ...normalizeApiReponse(order),
      basketId,
    }));
  }),
);

export const fetchCommittedOrderById = createAsyncThunk(
  REDUCER_KEY + '/getCommittedOrder',
  withErrorHandling(
    async ({ basketId, orderId }: { basketId: number; orderId: number }) => {
      const response = await adserver({
        url: `/basket/${basketId}/committed/orders/${orderId}`,
        headers: {},
      });

      return { ...normalizeApiReponse(response.data), basketId };
    },
  ),
);
